/**
 * #1612 — "Things I Keep Forgetting" (`reminder_nudge`) nudges her every week
 * until she taps Done. Kasandra's ruling, 2026-09-13.
 *
 * It already repeated, but by accident: the row had no cadence, and
 * run-scheduled-tasks falls back to +7 days for a task with no cadence
 * (`calculateNextRunAtLocal`). Nothing on the form, the toast, the card or the
 * task row said so, and the row actually read "Fires Daily" because the
 * label's fallback was 1 day. This makes the repeat deliberate and says so
 * wherever she sees the reminder.
 *
 * Tapping Done on the card is what stops it (`handleReminderNudgeDone` sets
 * `is_active: false`). That is why the copy names the button exactly.
 */

/** New rows store the weekly cadence instead of inheriting the runner's fallback. */
export const REMINDER_NUDGE_INTERVAL_DAYS = 7;

/** Under the "when" picker on the setup sheet. */
export const REMINDER_NUDGE_REPEAT_HINT = "Kin nudges you then, and every week after, until you tap Done.";

/** On the run card, just above Done / Later. */
export const REMINDER_NUDGE_CARD_NOTE = "Kin will nudge you again next week until you tap Done.";

/** Appended to every "reminder set" confirmation: the form toast and both chat toasts. */
export const REMINDER_NUDGE_TOAST_SUFFIX = "Weekly nudges until you tap Done.";
